var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSubtract = function SvgIcSubtract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm.75-12a.75.75 0 1 0-1.5 0v6.14L5.04 7.843a.75.75 0 0 0-1.08 1.04l3.5 3.636a.75.75 0 0 0 1.08 0l3.5-3.636a.75.75 0 0 0-1.08-1.04l-2.21 2.295V4Z",
    fill: "#B3B4B4"
  })));
};
export default SvgIcSubtract;